import { attachVideoToggles } from '/Foundation/Common/code/Views/Foundation/Common/VideoToggle';

window.addEventListener('DOMContentLoaded', attachVideoToggles);
